<template>
  <div>
    <div class="row">
      <div class="col-10">
        <InventorySummaryWidget :filter="filter" :gridHeight="320" />        
      </div>
      <div class="col-2">
        <AnalyticsWidget title="Detailed Reports" subTitle="Click to access the detailed reports" :gridHeight="320">
          <div class="p-2">
            <AnalyticsReportLink href="/analytics/reports/inventory/stockvalueonhand#tab-glass">Glass Stock Value List</AnalyticsReportLink>
            <AnalyticsReportLink href="/analytics/reports/inventory/stockvalueonhand#tab-general">General Stock Value List</AnalyticsReportLink>
            <AnalyticsReportLink href="/analytics/reports/inventory/inventoryvaluegroups">Inventory Summary Report</AnalyticsReportLink>
          </div>
        </AnalyticsWidget>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <DashboardTabbedContentBox :gridHeight="630" large>
          <template v-slot:tablist>
            <Tab :first="true" tabid="tab-inventory-stockvaluecat">
              <i class="tabbedbox-tab-icon fas fa-layer-group"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Categories</div>
                <div class="tabbedbox-tab-subtitle">Stock Value</div>
              </div>
            </Tab>
            <Tab tabid="tab-inventory-stockvalue">
              <i class="tabbedbox-tab-icon fas fa-inventory"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Stock</div>
                <div class="tabbedbox-tab-subtitle">Stock Value</div>
              </div>
            </Tab>
            <Tab tabid="tab-inventory-stockvalueoffcut">
              <i class="tabbedbox-tab-icon fas fa-layer-group"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Offcuts</div>
                <div class="tabbedbox-tab-subtitle">Stock Value</div>
              </div>
            </Tab>
            <Tab tabid="tab-inventory-stockvalueblock">
              <i class="tabbedbox-tab-icon fas fa-box"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Blocks</div>
                <div class="tabbedbox-tab-subtitle">Stock Value</div>
              </div>
            </Tab>
            <Tab tabid="tab-inventory-stockonhandcat">
              <i class="tabbedbox-tab-icon fas fa-layer-group"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Categories</div>
                <div class="tabbedbox-tab-subtitle">Stock On Hand</div>
              </div>
            </Tab>
            <Tab tabid="tab-inventory-stockonhand">
              <i class="tabbedbox-tab-icon fas fa-inventory"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Stock</div>
                <div class="tabbedbox-tab-subtitle">Stock On Hand</div>
              </div>
            </Tab>
            <Tab tabid="tab-inventory-offcut">
              <i class="tabbedbox-tab-icon fas fa-layer-group"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Offcuts</div>
                <div class="tabbedbox-tab-subtitle">Stock On Hand</div>
              </div>
            </Tab>
            <Tab tabid="tab-inventory-blockcount">
              <i class="tabbedbox-tab-icon fas fa-box"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Blocks</div>
                <div class="tabbedbox-tab-subtitle">Counts</div>
              </div>
            </Tab>
          </template>
          <template v-slot:tabcontent>
            <TabPage :first="true" tabid="tab-inventory-stockvaluecat" class="tabpage-padding-2">
              <StockValueChartWidget
                :type="StockValueChartTypes.stockValueCategory"
                :filter="filter"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
              />
            </TabPage>
            <TabPage tabid="tab-inventory-stockvalue" class="tabpage-padding-2">
              <StockValueChartWidget
                :type="StockValueChartTypes.stockValueStock"
                :filter="filter"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
              />              
            </TabPage>
            <TabPage tabid="tab-inventory-stockvalueoffcut" class="tabpage-padding-2">
              <StockValueChartWidget
                :type="StockValueChartTypes.stockValueOffcut"
                :filter="filter"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
              />              
            </TabPage>
            <TabPage tabid="tab-inventory-stockvalueblock" class="tabpage-padding-2">
              <StockValueChartWidget
                :type="StockValueChartTypes.stockValueBlock"
                :filter="filter"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
              />              
            </TabPage>
            <TabPage tabid="tab-inventory-stockonhandcat" class="tabpage-padding-2">
              <StockValueChartWidget
                :type="StockValueChartTypes.stockOnHandCategory"
                :filter="filter"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
              />
            </TabPage>
            <TabPage tabid="tab-inventory-stockonhand" class="tabpage-padding-2">
              <StockValueChartWidget
                :type="StockValueChartTypes.stockOnHandStock"
                :filter="filter"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
              />
            </TabPage>
            <TabPage tabid="tab-inventory-offcut" class="tabpage-padding-2">
              <StockValueChartWidget
                :type="StockValueChartTypes.stockOnHandOffcut"
                :filter="filter"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
              />
            </TabPage>
            <TabPage tabid="tab-inventory-blockcount" class="tabpage-padding-2">
              <StockValueChartWidget
                :type="StockValueChartTypes.stockOnHandBlock"
                :filter="filter"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
              />
            </TabPage>
          </template>
        </DashboardTabbedContentBox>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <DashboardTabbedContentBox :gridHeight="630" large>
          <template v-slot:tablist>
            <Tab :first="true" tabid="tab-stockvalue-daily">
              <i class="tabbedbox-tab-icon fas fa-calendar-day"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Daily</div>
                <div class="tabbedbox-tab-subtitle">Stock Value Chart</div>
              </div>
            </Tab>
            <Tab tabid="tab-stockvalue-monthly">
              <i class="tabbedbox-tab-icon fas fa-calendar-alt"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Monthly</div>
                <div class="tabbedbox-tab-subtitle">Stock Value Chart</div>
              </div>
            </Tab>
          </template>
          <template v-slot:tabcontent>
            <TabPage :first="true" tabid="tab-stockvalue-daily" class="tabpage-padding-2">
              <InventoryValueChartWidget :filter="filter" :gridHeight="500" :embedded="true" type="daily" />
            </TabPage>
            <TabPage tabid="tab-stockvalue-monthly" class="tabpage-padding-2">
              <InventoryValueChartWidget :filter="filter" :gridHeight="500" :embedded="true" type="monthly" />              
            </TabPage>
          </template>
        </DashboardTabbedContentBox>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <InventoryStockTreeMapWidget :filter="filter" :gridHeight="630" />
      </div>
    </div>

  </div>
</template>


<script>
import _ from 'lodash'
import moment from 'moment'

import DashboardTitle from '@/components/dashboard/dashboardTitle'
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'
import DashboardTabbedContentBox from '@/components/dashboard/dashboardTabbedContentBox'
import AnalyticsDashboardHeader from '@/modules/intelligence/components/analyticsDashboardHeader'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsReportLink from '@/modules/intelligence/components/analyticsReportLink'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'

import InventorySummaryWidget from '@/modules/intelligence/dashboardWidgets/inventorySummaryWidget'
import InventoryValueChartWidget from '@/modules/intelligence/dashboardWidgets/inventoryValueChartWidget'
import StockValueChartWidget from '@/modules/intelligence/dashboardWidgets/stockValueChartWidget'
import InventoryStockTreeMapWidget from '@/modules/intelligence/dashboardWidgets/inventoryStockTreeMapWidget'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'

export default {
  name: 'AnalyticsInventoryDashboard',
  components: {
    DashboardTitle,
    DashboardContentBox,
    DashboardTabbedContentBox,
    AnalyticsDashboardHeader,
    AnalyticsWidget,
    AnalyticsReportLink,
    AnalyticsDashboardValue,
    ReportFilterPopover,
    ReportDateRangeSelect,

    InventorySummaryWidget,
    InventoryValueChartWidget,
    StockValueChartWidget,
    InventoryStockTreeMapWidget
  },
  props: {
    filter: Object
  },
  data() {
    return {
      
    }
  },
  created() {
    this.StockValueChartTypes = StockValueChartWidget.StockValueChartTypes
  },
  mounted() {
    
  },
  beforeDestroy() {
    
  },
  methods: {
    
  }
  
}
</script>